module.exports = __webpack_public_path__ + "img/step02-active.347c201a.png";